import { Stack, styled } from "@mui/material";
import { FC } from "react";

type TFooterContainerProps = {
  children: React.ReactNode;
  height?: string | number;
};

export const FooterContainer: FC<TFooterContainerProps> = ({ children, height = "85px" }) => {
  return <StyleStack height={height}>{children}</StyleStack>;
};

const StyleStack = styled(Stack)<{ height?: string | number }>`
  position: sticky;
  bottom: 32px;
  left: 0;
  padding: 24px;
  border-top: 1px solid #e6e7e8;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 #00000026;
  z-index: 1000;
  height: ${(props) => props.height};
`;
